import http from '@services/http'
import {
  ICheerForTeamCreate,
  ICheerForTeamDelete,
  ISportTalkList,
  ISportTalkMatchDetailPackage,
  ISportTalkSimpleMatchInfo,
} from '@protocol/cheer-for-team'

class CheerForTeam {
  async fetchSportTalkList(params: ISportTalkList.Params): Promise<ISportTalkList.Schema> {
    return http.get('cheerForTeam/list', params || {})
  }

  async createCheerForTeam(params: ICheerForTeamCreate.Params): Promise<ICheerForTeamCreate.Schema> {
    return http.post('cheerForTeam/create', params || {})
  }

  async deleteCheerForTeam(params: ICheerForTeamDelete.Params): Promise<ICheerForTeamDelete.Schema> {
    return http.post('cheerForTeam/delete', params || {})
  }

  async sportTalkMatchDetailPackage(
    params: ISportTalkMatchDetailPackage.Params
  ): Promise<ISportTalkMatchDetailPackage.Schema> {
    return http.get('cheerForTeam/sportTalkMatchDetailPackage', params || {})
  }

  async fetchSportTalkSimpleMatchInfoTrack(
    params: ISportTalkSimpleMatchInfo.Params
  ): Promise<ISportTalkSimpleMatchInfo.Schema> {
    return http.get('cheerForTeam/fetchSportTalkSimpleMatchInfoTrack', params || {})
  }
}

export default new CheerForTeam()
